/* global axios */
import ApiClient from "dashboard/api/ApiClient";

class CRMPipelinesAPI extends ApiClient {
  constructor() {
    super("crm/pipelines", { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, { crm_pipeline: payload });
  }

  update(id, payload) {
    return axios.put(`${this.url}/${id}`, { crm_pipeline: payload });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getDeletionStats(id) {
    return axios.get(`${this.url}/${id}/deletion_stats`);
  }
}

export default new CRMPipelinesAPI();
